import React, { useState } from 'react';
import { Row, Tabs, Tab } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import ReturnFormsTab from './ProcurementReturns/ReturnFormsTab';
import SupplierViewTab from './ProcurementReturns/SupplierViewTab';
import ReturnsListTab from './ProcurementReturns/ReturnsListTab';

const TAB_KEYS = ['forms', 'suppliers', 'list'] as const;
type TabKey = (typeof TAB_KEYS)[number];

const resolveTab = (value: string | null): TabKey => {
  if (value === 'suppliers' || value === 'list' || value === 'forms') {
    return value;
  }
  return 'forms';
};

const ProcurementReturns = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [activeTab, setActiveTab] = useState<TabKey>(
    resolveTab(queryParams.get('tab'))
  );

  const handleTabSelect = (key: string | null) => {
    const nextTab = resolveTab(key);
    setActiveTab(nextTab);
    const nextParams = new URLSearchParams(location.search);
    nextParams.set('tab', nextTab);
    navigate({ search: nextParams.toString() }, { replace: true });
  };

  const openCreatedForm = (formId: number) => {
    const nextParams = new URLSearchParams(location.search);
    nextParams.set('tab', 'forms');
    nextParams.set('formId', String(formId));
    setActiveTab('forms');
    navigate({ search: nextParams.toString() }, { replace: true });
  };

  return (
    <>
      <Row lg="1" className="mb-3">
        <h4>Procurement Returns</h4>
      </Row>
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabSelect}
        className="mb-3"
        justify
      >
        <Tab eventKey="forms" title="Return Forms">
          {activeTab === 'forms' && <ReturnFormsTab />}
        </Tab>
        <Tab eventKey="suppliers" title="Supplier View">
          {activeTab === 'suppliers' && (
            <SupplierViewTab onFormCreated={openCreatedForm} />
          )}
        </Tab>
        <Tab eventKey="list" title="Returns List">
          {activeTab === 'list' && <ReturnsListTab />}
        </Tab>
      </Tabs>
    </>
  );
};

export default ProcurementReturns;
